import React, { useState } from "react";
import { Modal } from "antd";
import { media_collection_field_names } from "../../../utils/constants";
import { formatFileSize } from "../../../utils/helper";
import { Assets } from "../../../constants/images";

const MediaCollectionMessage = ({ message }) => {
  const mediaItems = message[media_collection_field_names.items] || [];
  const mediaCount = message[media_collection_field_names.count] || 0;
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);

  const formatMediaCount = (items) => {
    const images = items.filter(
      (item) => item[media_collection_field_names.type] === "image"
    ).length;
    const videos = items.filter(
      (item) => item[media_collection_field_names.type] === "video"
    ).length;

    const parts = [];
    if (images > 0) parts.push(`${images} Image${images > 1 ? "s" : ""}`);
    if (videos > 0) parts.push(`${videos} Video${videos > 1 ? "s" : ""}`);

    return `Attachments: ${parts.join(", ")}`;
  };

  const openModal = (index) => {
    setSelectedIndex(index);
    setShowModal(true);
  };

  const renderSingleMedia = (item, index) => {
    const mediaType = item[media_collection_field_names.type];
    const mediaUrl = item[media_collection_field_names.url];
    const thumbnailUrl = item[media_collection_field_names.thumbnail_url];

    if (mediaType === "image") {
      return (
        <img
          key={index}
          src={mediaUrl}
          alt=""
          className="single-media-image"
          onClick={() => openModal(index)}
          onError={(e) => (e.target.src = Assets.GeneralPlaceholder)}
        />
      );
    } else if (mediaType === "video") {
      return (
        <div
          key={index}
          className="video-container"
          onClick={() => openModal(index)}
        >
          <img
            src={thumbnailUrl || Assets.GeneralPlaceholder}
            alt=""
            className="video-thumbnail"
            onError={(e) => (e.target.src = Assets.GeneralPlaceholder)}
          />
          <div className="video-play-overlay">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
        </div>
      );
    }
    return null;
  };

  const renderThumbnailGrid = () => {
    if (mediaCount === 1) {
      return (
        <div className="media-collection-single">
          {renderSingleMedia(mediaItems[0], 0)}
        </div>
      );
    }

    return (
      <div className="media-collection-grid">
        <div className="media-grid-header">
          <span>{formatMediaCount(mediaItems)}</span>
        </div>
        <div className="media-thumbnails">
          {mediaItems.slice(0, 4).map((item, index) => {
            const mediaType = item[media_collection_field_names.type];
            const mediaUrl = item[media_collection_field_names.url];
            const thumbnailUrl =
              item[media_collection_field_names.thumbnail_url];

            return (
              <div
                key={index}
                className="media-thumbnail-item"
                onClick={() => openModal(index)}
              >
                {mediaType === "image" ? (
                  <img
                    src={mediaUrl}
                    alt=""
                    onError={(e) => (e.target.src = Assets.GeneralPlaceholder)}
                  />
                ) : (
                  <div className="video-thumbnail-container">
                    <img
                      src={thumbnailUrl || Assets.GeneralPlaceholder}
                      alt=""
                      onError={(e) =>
                        (e.target.src = Assets.GeneralPlaceholder)
                      }
                    />
                    <div className="video-play-overlay">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="white"
                      >
                        <path d="M8 5v14l11-7z" />
                      </svg>
                    </div>
                  </div>
                )}
                {mediaCount > 4 && index === 3 && (
                  <div className="more-overlay">+{mediaCount - 4}</div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const renderModalContent = () => {
    if (!mediaItems[selectedIndex]) return null;

    const item = mediaItems[selectedIndex];
    const mediaType = item[media_collection_field_names.type];
    const mediaUrl = item[media_collection_field_names.url];

    if (mediaType === "image") {
      return (
        <img
          src={mediaUrl}
          alt=""
          style={{ maxWidth: "100%", maxHeight: "80vh", objectFit: "contain" }}
          onError={(e) => (e.target.src = Assets.GeneralPlaceholder)}
        />
      );
    } else if (mediaType === "video") {
      return (
        <video
          src={mediaUrl}
          controls
          style={{ maxWidth: "100%", maxHeight: "80vh" }}
        />
      );
    }
    return null;
  };

  return (
    <>
      <div className="media-collection-container">{renderThumbnailGrid()}</div>
      <Modal
        open={showModal}
        onCancel={() => setShowModal(false)}
        footer={null}
        width="90vw"
        centered
        className="media-collection-modal"
      >
        <div className="modal-navigation">
          {selectedIndex > 0 && (
            <button
              className="nav-btn prev-btn"
              onClick={() => setSelectedIndex(selectedIndex - 1)}
            >
              ‹
            </button>
          )}
          {selectedIndex < mediaItems.length - 1 && (
            <button
              className="nav-btn next-btn"
              onClick={() => setSelectedIndex(selectedIndex + 1)}
            >
              ›
            </button>
          )}
        </div>
        <div className="modal-content">{renderModalContent()}</div>
        <div className="modal-info">
          <span>
            {selectedIndex + 1} of {mediaCount}
          </span>
        </div>
      </Modal>
    </>
  );
};

export default MediaCollectionMessage;
